// ══════════════════════════════════════════════════════════════════════════════════════════════
//  L21 (lista del 4-oct-2026) · CUANDO LA APP VUELVE A PEDIR LA CONTRASEÑA ESTANDO DENTRO
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «cuando pide la contraseña sabiendo que eres el mismo usuario pero por seguridad pide la contraseña de nuevo,
//  en esa situación no lee bien la contraseña en el iPhone y obliga a ponerla otra vez».
//
//  LAS DOS COSAS QUE HACEN FALTA EN UN IPHONE, y las dos estaban ya medidas en el portal (e8863ccf) y en la puerta de los
//  documentos personales (routes/contrasena-en-el-iphone):
//   1. QUE EL LLAVERO SEPA DE QUÉ CUENTA ES. Sin un <form> de verdad con una casilla de usuario (`autocomplete=username`) y
//      la de contraseña (`autocomplete=current-password`), el llavero de iCloud no sabe qué ofrecer: o no ofrece nada, o
//      toma por usuario cualquier otra casilla de la pantalla (el nombre del firmante, un código). La casilla del usuario va
//      OCULTA (utils/codigoDeUnSoloUso · usuarioOculto): quien está dentro no tiene que volver a escribir su correo.
//   2. QUE LA CONTRASEÑA QUE PONE EL LLAVERO SE LEA. Cuando el llavero la rellena con Face ID, el valor queda EN LA CASILLA
//      pero el `onChange` de React no siempre salta: la pantalla cree que está vacía y dice «escribe tu contraseña», o manda
//      una vacía y el servidor contesta que no es. Se lee del formulario al enviarlo; lo tecleado sigue mandando.
//
//  Guardia: routes/contrasena-de-nuevo-en-el-iphone.test.js (las pantallas montadas y el censo de formularios).
import { usuarioOculto } from './codigoDeUnSoloUso'

// El correo de la sesión abierta (el que guarda AuthContext en `user`). Vacío si no se puede leer: entonces la casilla
// del usuario va vacía y el llavero ofrece sus cuentas, que es lo de antes.
export function correoDeLaSesion() {
  try {
    const u = JSON.parse((typeof localStorage !== 'undefined' && localStorage.getItem('user')) || 'null')
    return u && typeof u.email === 'string' ? u.email.trim() : ''
  } catch { return '' }
}

// La casilla OCULTA del usuario de esta sesión. `correo` manda si se pasa (la pantalla que ya lo tiene a mano).
export function usuarioDeLaSesion(correo) {
  return usuarioOculto(typeof correo === 'string' && correo.trim() ? correo.trim() : correoDeLaSesion())
}

// Lo que va en la casilla de la contraseña de quien ya está dentro.
export const CONTRASENA_ACTUAL = {
  name: 'password',
  autoComplete: 'current-password',
  autoCapitalize: 'none',
  autoCorrect: 'off',
  spellCheck: false,
}

// La contraseña que de verdad hay: lo tecleado (el estado de la pantalla) y, si está vacío, lo que el llavero dejó en la
// casilla `nombre` del formulario. Nunca lanza.
export function contrasenaDelFormulario(form, estado, nombre = 'password') {
  if (typeof estado === 'string' && estado) return estado
  try {
    const c = form && form.elements && form.elements[nombre]
    return c && typeof c.value === 'string' ? c.value : ''
  } catch { return '' }
}
